import i18n from 'i18next'
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { getLanguageSelected } from "beaktShared/services/session";
var language = getLanguageSelected();

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: language,
    fallbackLng: language,
    debug: false,
    interpolation: {
      escapeValue: false
    },
  });

export default i18n;